// extracted by mini-css-extract-plugin
export default {"conversationContainer":"Conversations_conversationContainer__eggzD"};